// extracted by mini-css-extract-plugin
module.exports = {"black":"#0a0a0a","darkGrey":"#101012","grey":"#8a8c93","bgSphere":"#1c1d21","bgSphereInit":"#27282d","insideSphere":"#121214","grey800":"#131416"};